import { render, staticRenderFns } from "./template.vue?vue&type=template&id=010e08f3&scoped=true&"
import script from "@/Components/Modules/CheckList/AttributesList/component.ts?vue&type=script&lang=ts&"
export * from "@/Components/Modules/CheckList/AttributesList/component.ts?vue&type=script&lang=ts&"
import style0 from "@/Components/Modules/CheckList/AttributesList/style.scss?vue&type=style&index=0&id=010e08f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010e08f3",
  null
  
)

export default component.exports